import React, { useEffect, useState } from 'react';
import APNavBar from '../Elements/APNavBar';
import APSidebar from '../APSidebar/APSidebar';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import axios from 'axios';
import BaseApi from '../../api/BaseApi';
import ApiKey from '../../api/ApiKey';
import Swal from 'sweetalert2';
import { useNavigate, useParams } from 'react-router-dom';
import Cookies from 'js-cookie';

const APAddSubCategory = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const tokenKey = Cookies.get('token');
  const adminID = Cookies.get('adminID');

  const [loading, setLoading] = useState(false);
  const [userData, setUserData] = useState({
    name_en: '',
    name_ru: '',
    name_uk: '',
  });
  const [errors, setErrors] = useState({
    name_en: '',
    name_ru: '',
    name_uk: '',
  });

  const handleChange = e => {
    const { name, value } = e.target;

    setUserData(prev => ({
      ...prev,
      [name]: value,
    }));

    setErrors(prev => ({
      ...prev,
      [name]: '',
    }));
  };

  const getData = async () => {
    try {
      setLoading(true);

      const response = await axios.post(
        BaseApi + `/admin/subcategory/admin_add/${slug}`,
        null,
        {
          headers: {
            key: ApiKey,
            adminid: adminID,
            ContentType: 'application/json',
            Authorization: `Bearer ${tokenKey}`,
          },
        },
      );

      setLoading(false);
      setUserData({
        name_en: '',
        name_ru: '',
        name_uk: '',
        ...response.data.response,
      });
    } catch (error) {
      setLoading(false);

      console.error('Error at chnage username at Admin panel', error);
    }
  };

  const handleClick = async () => {
    try {
      const newErrors = {};

      if (userData.name_en === '') {
        newErrors.name_en = 'Sub Category Name (en) is required';
        window.scrollTo(0, 0);
      }
      if (userData.name_ru === '') {
        newErrors.name_ru = 'Sub Category Name (ru) is required';
        window.scrollTo(0, 0);
      }
      if (userData.name_uk === '') {
        newErrors.name_uk = 'Sub Category Name (uk) is required';
        window.scrollTo(0, 0);
      }

      setErrors(newErrors);

      if (Object.keys(newErrors).length === 0) {
        const confirmationResult = await Swal.fire({
          icon: 'question',
          cancelButtonText: 'No',
          showCancelButton: true,
          confirmButtonText: 'Yes',
          title: 'Add Sub Category',
          text: 'Do you want to add Sub Category?',
        });

        if (confirmationResult.isConfirmed) {
          setLoading(true);

          const response = await axios.post(
            BaseApi + `/admin/subcategory/admin_add/${slug}`,
            userData,
            {
              headers: {
                key: ApiKey,
                adminid: adminID,
                ContentType: 'application/json',
                Authorization: `Bearer ${tokenKey}`,
              },
            },
          );

          setLoading(false);

          if (response.data.status === 200) {
            Swal.fire({
              icon: 'success',
              confirmButtonText: 'Close',
              title: 'Sub Category successfully!',
            });

            navigate(`/admin/categories/subindex/${slug}`);
          } else {
            Swal.fire({
              icon: 'error',
              confirmButtonText: 'Close',
              title: response.data.message,
            });
          }
        }
      }
    } catch (error) {
      setLoading(false);

      Swal.fire({
        icon: 'error',
        title: 'Failed',
        confirmButtonText: 'Close',
        text: 'Could not update username. Please try again later!',
      });

      console.error('Could not change username!', error);
    }
  };

  const handleReset = () => {
    setUserData({
      name_en: '',
      name_ru: '',
      name_uk: '',
    });

    setErrors({
      name_en: '',
      name_ru: '',
      name_uk: '',
    });
  };

  useEffect(() => {
    if (!tokenKey) {
      navigate('/admin');
    } else {
      getData();

      window.scrollTo(0, 0);
    }
  }, [tokenKey, navigate]); // eslint-disable-line

  return (
    <>
      <APNavBar />
      <div className='APBasic'>
        <APSidebar />
        {
          loading
            ? (
              <div className='loader-container' />
            ) : (
              <div className='site-min-height'>
                <div className='breadCumb' role='presentation'>
                  <Breadcrumbs
                    aria-label='breadcrumb'
                    separator={<NavigateNextIcon fontSize='small' />}
                  >
                    <Link
                      underline='hover'
                      color='inherit'
                      onClick={() => navigate('/admin/admins/dashboard')}
                    >
                      Dashboard
                    </Link>
                    <Link
                      underline='hover'
                      color='inherit'
                      onClick={() => navigate('/admin/categories')}
                    >
                      Categories
                    </Link>
                    <Link
                      color='inherit'
                      underline='hover'
                      onClick={() => window.history.back()}
                    >
                      {userData?.cateogory_name}
                    </Link>
                    <Typography color='text.primary'>Add Sub Category</Typography>
                  </Breadcrumbs>
                </div>
                <h2 className='adminPageHeading'>Add Sub Category</h2>
                <form className='adminForm'>
                  <div className='mb-4 mt-5'>
                    <div className='mb-5 DashBoardInputBx'>
                      <label htmlFor='formFile' className='form-label'>
                        Sub Category Name (uk) <span className='RedStar'>*</span>
                      </label>
                      <input
                        type='text'
                        id='name_uk'
                        name='name_uk'
                        onChange={handleChange}
                        value={userData.name_uk}
                        placeholder='Sub Category Name (uk)'
                        className={`form-control ${errors.name_uk && 'input-error'}`}
                      />
                      {
                        errors.name_uk && (
                          <div className='text-danger'>{errors.name_uk}</div>
                        )
                      }
                    </div>
                    <div className='mb-5 DashBoardInputBx'>
                      <label htmlFor='formFile' className='form-label'>
                        Sub Category Name (ru) <span className='RedStar'>*</span>
                      </label>
                      <input
                        type='text'
                        id='name_ru'
                        name='name_ru'
                        onChange={handleChange}
                        value={userData.name_ru}
                        placeholder='Sub Category Name (ru)'
                        className={`form-control ${errors.name_ru && 'input-error'}`}
                      />
                      {
                        errors.name_ru && (
                          <div className='text-danger'>{errors.name_ru}</div>
                        )
                      }
                    </div>
                    <div className='mb-5 DashBoardInputBx'>
                      <label htmlFor='formFile' className='form-label'>
                        Sub Category Name (en) <span className='RedStar'>*</span>
                      </label>
                      <input
                        type='text'
                        id='name_en'
                        name='name_en'
                        onChange={handleChange}
                        value={userData.name_en}
                        placeholder='Sub Category Name (en)'
                        className={`form-control ${errors.name_en && 'input-error'}`}
                      />
                      {
                        errors.name_en && (
                          <div className='text-danger'>{errors.name_en}</div>
                        )
                      }
                    </div>
                    <div className='adminBottomButtons'>
                      <button
                        type='button'
                        onClick={handleClick}
                        className='btn btn-primary button1'
                      >
                        SAVE
                      </button>
                      <button
                        type='button'
                        onClick={() => handleReset()}
                        className='btn btn-primary button2'
                      >
                        RESET
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            )
        }
      </div>
    </>
  );
};

export default APAddSubCategory;
